import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// 创建路由实例
const router = new Router({
  mode: "history",
  routes: [
    // 登录路由
    {
      path: "/login",
      name: "login",
      component: () => import("@/pages/login/index.vue"),
      meta: { requiresAuth: false, title: "登录" }
    },
    // 首页路由
    {
      path: "/",
      name: "home",
      component: () => import("@/pages/home/index.vue"),
      meta: { requiresAuth: false, title: "首页" }
    },
    // 集团概况路由
    {
      path: "/about",
      name: "CompanyProfile",
      component: () => import("@/pages/home/company_profile.vue"),
      meta: { requiresAuth: false, title: "集团概况" }
    },
    // 党群工作路由
    {
      path: "/party",
      name: "PartyWork",
      component: () => import("@/pages/home/party_work.vue"),
      meta: { requiresAuth: false, title: "党群工作" }
    },
    {
      path: "/party/detail/:id",
      name: "PartyWorkDetail",
      component: () => import("@/pages/home/party_work_detail.vue"),
      meta: { requiresAuth: false, title: "党群工作详情" }
    },
    // 纪检监察路由
    {
      path: "/supervision",
      name: "DisciplineInspection",
      component: () => import("@/pages/home/discipline_inspection.vue"),
      meta: { requiresAuth: false, title: "纪检监察" }
    },
    {
      path: "/discipline_inspection",
      name: "DisciplineInspectionAlias",
      component: () => import("@/pages/home/discipline_inspection.vue"),
      meta: { requiresAuth: false, title: "纪检监察" }
    },
    {
      path: "/supervision/detail/:id",
      name: "DisciplineInspectionDetail",
      component: () => import("@/pages/home/discipline_inspection_detail.vue"),
      meta: { requiresAuth: false, title: "纪检监察详情" }
    },
    // 新闻中心路由
    {
      path: "/news",
      name: "NewsCenter",
      component: () => import("@/pages/home/news_center.vue"),
      meta: { requiresAuth: false, title: "新闻中心" }
    },
    {
      path: "/news/detail",
      name: "NewsDetail",
      component: () => import("@/pages/home/news_detail.vue"),
      meta: { requiresAuth: false, title: "新闻详情" }
    },
    {
      path: "/news/group",
      name: "GroupNews",
      component: () => import("@/pages/home/news_center.vue"),
      meta: { requiresAuth: false, title: "集团动态" }
    },
    {
      path: "/news/safety",
      name: "SafetyNews",
      component: () => import("@/pages/home/news_center.vue"),
      meta: { requiresAuth: false, title: "安全生产" }
    },
    {
      path: "/news/notice",
      name: "SpecialNotice",
      component: () => import("@/pages/home/news_center.vue"),
      meta: { requiresAuth: false, title: "特精公告" }
    },
    {
      path: "/news/announcement",
      name: "Announcement",
      component: () => import("@/pages/home/news_center.vue"),
      meta: { requiresAuth: false, title: "通知公告" }
    },
    // 内容管理路由
    {
      path: "/content",
      name: "content",
      component: () => import("@/pages/cms/content.vue"),
      meta: { requiresAuth: true, title: "内容管理" }
    },
    // 其他路由
    {
      path: "/category",
      name: "category",
      component: () => import("@/pages/cms/category.vue"),
      meta: { requiresAuth: true, title: "分类管理" }
    },
    {
      path: "/user",
      name: "user",
      component: () => import("@/pages/cms/user.vue"),
      meta: { requiresAuth: true, title: "用户管理" }
    },
    {
      path: "/system",
      name: "system",
      component: () => import("@/pages/cms/system.vue"),
      meta: { requiresAuth: true, title: "系统设置" }
    },
    // 留言管理路由
    {
      path: "/message",
      name: "message",
      component: () => import("@/pages/cms/message.vue"),
      meta: { requiresAuth: true, title: "留言管理" }
    },
    // 联系方式设置路由
    {
      path: "/contact",
      name: "contact",
      component: () => import("@/pages/cms/contact.vue"),
      meta: { requiresAuth: true, title: "联系方式设置" }
    },
    // 政务公开路由
    {
      path: "/open_affairs",
      name: "OpenAffairs",
      component: () => import("@/pages/home/open_affairs.vue"),
      meta: { requiresAuth: false, title: "政务公开" }
    },
    {
      path: "/open_affairs/detail/:id",
      name: "OpenAffairsDetail",
      component: () => import("@/pages/home/open_affairs_detail.vue"),
      meta: { requiresAuth: false, title: "政务公开详情" }
    },
    // 搜索结果页面路由
    {
      path: "/search_result",
      name: "SearchResult",
      component: () => import("@/pages/home/search_result.vue"),
      meta: { requiresAuth: false, title: "搜索结果" }
    },
    // 招标采购路由
    {
      path: "/tender",
      name: "TenderPurchase",
      component: () => import("@/pages/home/tender_purchase.vue"),
      meta: { requiresAuth: false, title: "招标采购" }
    },
    {
      path: "/tender/detail",
      name: "TenderDetail",
      component: () => import("@/pages/home/news_detail.vue"),
      meta: { requiresAuth: false, title: "招标详情" }
    },
    {
      path: "/tender/announcement",
      name: "TenderAnnouncement",
      component: () => import("@/pages/home/tender_purchase.vue"),
      meta: { requiresAuth: false, title: "招标公告" }
    },
    {
      path: "/tender/bid",
      name: "BidNotice",
      component: () => import("@/pages/home/tender_purchase.vue"),
      meta: { requiresAuth: false, title: "中标公示" }
    },
    {
      path: "/tender/purchase",
      name: "PurchaseInfo",
      component: () => import("@/pages/home/tender_purchase.vue"),
      meta: { requiresAuth: false, title: "采购信息" }
    },
    // 前台联系我们页面路由
    {
      path: "/contact_us",
      name: "ContactUs",
      component: () => import("@/pages/home/contact_us.vue"),
      meta: { requiresAuth: false, title: "联系我们" }
    },
    // 单页文章管理路由
    {
      path: "/article",
      name: "article",
      component: () => import("@/pages/cms/article.vue"),
      meta: { requiresAuth: true, title: "单页文章管理" }
    },
    // 404路由
    {
      path: "*",
      redirect: "/"
    }
  ]
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title
    ? `${to.meta.title} - 狮城能源集团网站`
    : "狮城能源集团网站";

  // 检查是否需要登录
  // if (to.meta.requiresAuth) {
  //   // 检查是否已登录（从缓存中获取token）
  //   const token = localStorage.getItem('TSB_token')

  //   if (token) {
  //     // 已登录，可以访问
  //     next()
  //   } else {
  //     // 未登录，重定向到登录页
  //     next({ path: '/login' })
  //   }
  // } else {
  //   // 不需要登录的页面，直接访问
  //   next()
  // }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js